import { useState, useEffect, useLayoutEffect } from "react";
import { SM_PIXEL_MIN, XS_PIXEL_MAX } from "constants/breakpoints";

const useWindowResizeAndFormCollapse = () => {
  const [isLessThanSmallBreakpoint, setIsLessThanSmallBreakpoint] =
    useState(true);
  const [collapsed, setCollapsed] = useState(true);

  const resizeHandler = () => {
    if (window.matchMedia(`(min-width: ${SM_PIXEL_MIN}px)`).matches) {
      setIsLessThanSmallBreakpoint(false);
    } else if (window.matchMedia(`(max-width: ${XS_PIXEL_MAX}px)`).matches) {
      setIsLessThanSmallBreakpoint(true);
    }
  };

  useEffect(() => {
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  useEffect(() => {
    // Prevent the body from scrolling underneath the form field when on small screen
    // and expanded
    if (!collapsed && isLessThanSmallBreakpoint) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [collapsed, isLessThanSmallBreakpoint]);

  useLayoutEffect(() => {
    setCollapsed(isLessThanSmallBreakpoint);
  }, [isLessThanSmallBreakpoint]);

  return { collapsed, isLessThanSmallBreakpoint, setCollapsed };
};

export default useWindowResizeAndFormCollapse;
